import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LinkListTrustyle, LinkListTrustyleItem } from '../../elements/link-list';
import LinkListSpark from './link-list';
import LinkListItemSpark from './link-list-item';
import { connectEntityWithProps } from '../../helpers/connect-entity';
import { useEntity, useMeta } from '@uswitch/ev-utils/context/selectors';
import { contentTypeId } from '@uswitch/ev-utils/contentful';
import { usePageForUrlEntity } from '../../../utils/url';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var UrlChild = function UrlChild(props) {
  var _page$title;

  var pageEntity = usePageForUrlEntity(props);
  var page = useEntity(pageEntity);
  var homePath = useMeta(['breadcrumbs', 'homePath'], '');
  var href = props.url ? props.url[0] === '/' ? props.url : "".concat(homePath, "/").concat(props.url) : '';
  var ChildElement = (props === null || props === void 0 ? void 0 : props.listVariant) === 'subcategoryNavigation' ? LinkListItemSpark : LinkListTrustyleItem;
  return href ? _jsx(ChildElement, {
    href: href,
    children: (_page$title = page === null || page === void 0 ? void 0 : page.title) !== null && _page$title !== void 0 ? _page$title : href
  }) : null;
};

var LinkListItemChild = function LinkListItemChild(props) {
  var _useEntity, _props$urlRef;

  var href = (_useEntity = useEntity((_props$urlRef = props.urlRef) !== null && _props$urlRef !== void 0 ? _props$urlRef : props)) === null || _useEntity === void 0 ? void 0 : _useEntity.url;
  var homePath = useMeta(['breadcrumbs', 'homePath'], '');
  var ChildElement = (props === null || props === void 0 ? void 0 : props.listVariant) === 'subcategoryNavigation' ? LinkListItemSpark : LinkListTrustyleItem;

  if (props !== null && props !== void 0 && props.urlRef) {
    return _jsx(ChildElement, _objectSpread(_objectSpread({}, props), {}, {
      href: href[0] === '/' ? href : "".concat(homePath, "/").concat(href),
      children: props.title
    }));
  }

  return _jsx(ChildElement, _objectSpread(_objectSpread({}, props), {}, {
    href: props.url,
    children: props.title
  }));
};

var ConnectedLinkListChild = connectEntityWithProps()(function (props) {
  var childType = contentTypeId(props);
  return childType === 'url' ? _jsx(UrlChild, _objectSpread({}, props)) : _jsx(LinkListItemChild, _objectSpread({}, props));
});

var LinkListCompound = function LinkListCompound(_ref) {
  var title = _ref.title,
      _ref$links = _ref.links,
      links = _ref$links === void 0 ? [] : _ref$links,
      variant = _ref.variant,
      subtitle = _ref.subtitle,
      subtitleUrl = _ref.subtitleUrl,
      icon = _ref.icon;
  var LinkListElement = variant === 'subcategoryNavigation' ? LinkListSpark : LinkListTrustyle;

  var LinkListFragment = _jsx(LinkListElement, {
    title: title,
    variant: variant,
    subtitle: subtitle,
    subtitleUrl: subtitleUrl,
    icon: icon,
    children: links.map(function (link, i) {
      return _jsx(ConnectedLinkListChild, {
        listVariant: variant,
        entity: link
      }, i);
    }, this)
  });

  if (variant === 'subcategoryNavigation') {
    return LinkListFragment;
  }

  return _jsx("div", {
    sx: {
      pt: 'sm'
    },
    children: LinkListFragment
  });
};

export default LinkListCompound;
//# sourceMappingURL=index.js.map